import { fmtDate, type UserActivity } from "../activity";

export default function ActivityCertificates({ activity }: { activity: UserActivity }) {
  const certs = activity.certificates;

  if (certs.length === 0) {
    return (
      <p className="text-sm text-foreground-500 text-center py-8">
        Bu öğrenci henüz sertifika kazanmamış.
      </p>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {certs.map((c) => (
        <div
          key={c.id}
          className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
        >
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 shrink-0">
            <i className={`${c.icon || "ri-award-line"} text-lg`} aria-hidden="true"></i>
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground-900">{c.title}</p>
            {c.description && (
              <p className="mt-0.5 text-xs text-foreground-600 line-clamp-2">{c.description}</p>
            )}
            {c.earned_date && (
              <p className="mt-1 text-xs text-foreground-500">Kazanıldı: {fmtDate(c.earned_date)}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}